module.exports = __webpack_public_path__ + "static/img/8.15bc93d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/8.png
// module id = NWK8
// module chunks = 12